// extracted by mini-css-extract-plugin
module.exports = {"track":"Frames_track__lp4nP","frame":"Frames_frame__G7FNT","img":"Frames_img__RA4Qf"};